import { createAction, props } from '@ngrx/store';
import { BusinessCard, JobInformation } from '@planone/bau365/util-user-data';

export const openPage = createAction('[Business Card/Page] Open');

export const loadBusinessCard = createAction('[Business Card/Page] Load business card', props<{ id: string }>());
export const loadBusinessCardSuccess = createAction(
  '[Business Card/Service] Load business card success',
  props<{ businessCard: BusinessCard }>()
);
export const loadBusinessCardUnknown = createAction('[Business Card/Service] Loaded business card unknown');
export const loadBusinessCardFailure = createAction(
  '[Business Card/Service] Load business card failure',
  props<{ error: unknown }>()
);

export const enrichBusinessCard = createAction(
  '[Business Card/Page] Enrich business card',
  props<{ businessCard: BusinessCard }>()
);
export const enrichBusinessCardSuccess = createAction(
  '[Business Card/Page] Enrich business card success',
  props<{ businessCard: BusinessCard }>()
);
export const enrichBusinessCardFailure = createAction(
  '[Business Card/Page] Enrich business card failure',
  props<{ error: unknown }>()
);

export const downloadBusinessCard = createAction(
  '[Business Card/Service] Download business card',
  props<{ businessCard: JobInformation }>()
);
